// extracted by mini-css-extract-plugin
export var ourTeam = "team-members-module--our-team--dq5pS";
export var teamMembers = "team-members-module--team-members--3Wn55";
export var teamMember = "team-members-module--team-member--Zw6HT";
export var teamMemberName = "team-members-module--team-member-name--QtcsU";